"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  common: {
    ok: 'OK',
    error: 'Fout',
    errorTitle: 'Fout',
    success: 'Succes',
    unexpectedError: 'Sorry, er is een onverwachte fout opgetreden. Probeer het later opnieuw.'
  },
  imageDocumentPreview: {
    error: 'Voorbeeld van afbeelding niet beschikbaar'
  },
  pdfDocumentPreview: {
    pdfError: 'Voorbeeld van PDF niet beschikbaar',
    empty: 'Er is geen bestand'
  },
  date: {
    rangeFilterName: 'Datumbereik',
    any: 'Elke tijd',
    startDate: 'Startdatum',
    endDate: 'Einddatum',
    rangeSeparator: 'tot',
    placeholder: 'Datum',
    presets: {
      today: 'Vandaag',
      thisWeek: 'Deze week',
      lastWeek: 'Vorige week',
      thisMonth: 'Deze maand',
      lastMonth: 'Vorige maand'
    }
  },
  tableFooter: {
    showing: 'Weergegeven {{pageStart}} tot {{pageEnd}} van {{totalItemsCount}} {{dataName}}',
    mobileShowing: 'Weergegeven {{pageStart}} - {{pageEnd}} {{dataName}}'
  },
  emailBox: {
    emailInvoice: 'Stuur ons uw factuur (leveranciers kunnen dit ook gebruiken):',
    emailSupliersCompleteData: 'Stuur leveranciers een link om hun gegevens in te vullen:',
    emailSupliersSendQuote: 'Stuur leveranciers een link om een offerte te sturen:',
    copied: 'Gekopieerd!'
  },
  amountCell: {
    converted: 'Omgezet:'
  },
  addFiltersToggle: {
    add: 'Filters toevoegen'
  },
  filtersLayout: {
    search: 'Zoeken...'
  },
  settingsLayout: {
    title: 'Instellingen'
  },
  reportsLayout: {
    title: 'Rapporten'
  },
  additionalFiltersLayout: {
    filterBy: 'Filter op',
    apply: 'Filters toepassen',
    clear: 'Filters wissen'
  },
  fileUploader: {
    buttonText: 'Bestand uploaden',
    fileSizeError: 'Bestandsgrootte mag niet groter zijn dan {{maxSizeMb}}MB.',
    defaultEmptyText: 'Geen bestand geselecteerd'
  },
  fileDropZone: {
    remove: 'Verwijderen',
    browse: 'of hier bladeren'
  },
  statusLabel: {
    approved: 'GOEDGEKEURD',
    pending: 'IN AFWACHTING',
    awaitingApproval: 'IN AFWACHTING VAN GOEDKEURING',
    notSubmitted: 'NIET INGEDIEND',
    draft: 'KLAAD',
    cancelled: 'GEANNULEERD',
    declined: 'AFGEWEZEN',
    completed: 'VOLTOOID'
  },
  errors: {
    pageNotFound: 'Deze pagina kon niet worden gevonden.',
    unexpectedError: 'Er is iets misgegaan, neem contact op met de ondersteuning.',
    returnToLogin: 'Terug naar inloggen',
    error: 'Fout',
    uiSettingsIssue: 'Er is een probleem met de UI-instellingen.'
  },
  inputPassword: {
    hide: 'Verbergen',
    show: 'Weergeven'
  },
  inputAmount: {
    popularGroup: 'Populair',
    otherGroup: 'Overig'
  },
  phonePicker: {
    searchPlaceholder: 'Typ om te zoeken...',
    noCountriesText: 'Geen landen gevonden'
  },
  multiPhonePicker: {
    addNewLabel: 'Extra telefoonnummer toevoegen'
  },
  formField: {
    optional: '(Optioneel)'
  },
  dateCell: {
    futurePayment: 'Toekomstige betaling'
  },
  multiSearchSelect: {
    all: 'Alle',
    selectAll: 'Selecteer alles',
    deselectAll: 'Deselecteer alles',
    noOptions: 'Geen opties gevonden'
  },
  currencies: {
    AED: 'Verenigde Arabische Emiraten dirham',
    AFN: 'Afghaanse afghani',
    ALL: 'Albanese lek',
    AMD: 'Armeense dram',
    ANG: 'Nederlandse Antilliaanse gulden',
    AOA: 'Angolese kwanza',
    ARS: 'Argentijnse peso',
    AUD: 'Australische dollar',
    AWG: 'Arubaanse florin',
    AZN: 'Azerbeidzjaanse manat',
    BAM: 'Bosnische en Herzegovinische converteerbare mark',
    BBD: 'Barbadaanse dollar',
    BDT: 'Bengaalse taka',
    BGN: 'Bulgaarse lev',
    BHD: 'Bahreinse dinar',
    BIF: 'Burundese frank',
    BMD: 'Bermuda dollar',
    BND: 'Bruneise dollar',
    BOB: 'Boliviaanse boliviano',
    BRL: 'Braziliaanse real',
    BSD: 'Bahamaanse dollar',
    BTN: 'Bhutaanse ngultrum',
    BWP: 'Botswaanse pula',
    BYN: 'Wit-Russische roebel',
    BZD: 'Belizaanse dollar',
    CAD: 'Canadese dollar',
    CDF: 'Congolese frank',
    CHF: 'Zwitserse frank',
    CLP: 'Chileense peso',
    CNY: 'Chinese yuan',
    COP: 'Colombiaanse peso',
    CRC: 'Costa Ricaanse colón',
    CUC: 'Cubaanse converteerbare peso',
    CVE: 'Kaapverdische escudo',
    CZK: 'Tsjechische kroon',
    DJF: 'Djiboutiaanse frank',
    DKK: 'Deense kroon',
    DOP: 'Dominicaanse peso',
    DZD: 'Algerijnse dinar',
    EGP: 'Egyptische pond',
    ERN: 'Eritrese nakfa',
    ETB: 'Ethiopische birr',
    EUR: 'Euro',
    FJD: 'Fiji dollar',
    FKP: 'Falklandeilanden pond',
    GBP: 'Britse pond',
    GEL: 'Georgische lari',
    GHS: 'Ghanese cedi',
    GIP: 'Gibraltar pond',
    GMD: 'Gambiaanse dalasi',
    GNF: 'Guinese frank',
    GTQ: 'Guatemalteekse quetzal',
    GYD: 'Guyaanse dollar',
    HKD: 'Hongkong dollar',
    HNL: 'Hondurese lempira',
    HRK: 'Kroatische kuna',
    HTG: 'Haïtiaanse gourde',
    HUF: 'Hongaarse forint',
    IDR: 'Indonesische roepia',
    ILS: 'Israëlische nieuwe sjekel',
    INR: 'Indiase roepie',
    IQD: 'Iraakse dinar',
    IRR: 'Iraanse rial',
    ISK: 'IJslandse kroon',
    JMD: 'Jamaicaanse dollar',
    JOD: 'Jordaanse dinar',
    JPY: 'Japanse yen',
    KES: 'Keniaanse shilling',
    KGS: 'Kirgizische som',
    KHR: 'Cambodjaanse riel',
    KMF: 'Comorese frank',
    KPW: 'Noord-Koreaanse won',
    KRW: 'Zuid-Koreaanse won',
    KWD: 'Koeweitse dinar',
    KYD: 'Caymaneilandse dollar',
    KZT: 'Kazachse tenge',
    LAK: 'Laotiaanse kip',
    LBP: 'Libanese pond',
    LKR: 'Sri Lankaanse roepie',
    LRD: 'Liberiaanse dollar',
    LSL: 'Lesothaanse loti',
    LYD: 'Libische dinar',
    MAD: 'Marokkaanse dirham',
    MDL: 'Moldavische leu',
    MGA: 'Malagassische ariary',
    MKD: 'Macedonische denar',
    MMK: 'Myanmarese kyat',
    MNT: 'Mongoolse tugrik',
    MOP: 'Macause pataca',
    MRO: 'Mauritaanse ouguiya',
    MUR: 'Mauritiaanse roepie',
    MVR: 'Maldivische rufiyaa',
    MWK: 'Malawische kwacha',
    MXN: 'Mexicaanse peso',
    MYR: 'Maleisische ringgit',
    MZN: 'Mozambikaanse metical',
    NAD: 'Namibische dollar',
    NGN: 'Nigeriaanse naira',
    NIO: 'Nicaraguaanse cordoba',
    NOK: 'Noorse kroon',
    NPR: 'Nepalese roepie',
    NZD: 'Nieuw-Zeelandse dollar',
    OMR: 'Omaanse rial',
    PAB: 'Panamese balboa',
    PEN: 'Peruaanse sol',
    PGK: 'Papoea-Nieuw-Guinese kina',
    PHP: 'Filipijnse peso',
    PKR: 'Pakistaanse roepie',
    PLN: 'Poolse zloty',
    PYG: 'Paraguayaanse guarani',
    QAR: 'Qatarese rial',
    RON: 'Roemeense leu',
    RSD: 'Servische dinar',
    RUB: 'Russische roebel',
    RWF: 'Rwandese frank',
    SAR: 'Saoedische riyal',
    SBD: 'Salomon-dollar',
    SCR: 'Seychelse roepie',
    SDG: 'Soedanese pond',
    SEK: 'Zweedse kroon',
    SGD: 'Singapore dollar',
    SHP: 'Sint-Heleense pond',
    SLL: 'Sierra Leoonse leone',
    SOS: 'Somalische shilling',
    SRD: 'Surinaamse dollar',
    STN: 'Santomese dobra',
    SVC: 'Salvadoraanse colón',
    SYP: 'Syrische pond',
    SZL: 'Swazische lilangeni',
    THB: 'Thaise baht',
    TJS: 'Tadzjiekse somoni',
    TMT: 'Turkmeense manat',
    TND: 'Tunesische dinar',
    TOP: 'Tongaanse paʻanga',
    TRY: 'Turkse lira',
    TTD: 'Trinidad en Tobago dollar',
    TWD: 'Taiwanese dollar',
    TZS: 'Tanzaniaanse shilling',
    UAH: 'Oekraïense grivna',
    UGX: 'Oegandese shilling',
    USD: 'Amerikaanse dollar',
    UYU: 'Uruguayaanse peso',
    UZS: 'Oezbeekse som',
    VND: 'Vietnamese dong',
    VUV: 'Vanuatuaanse vatu',
    WST: 'Samoaanse tala',
    XAF: 'Centraal-Afrikaanse CFA-frank',
    XCD: 'Oost-Caribische dollar',
    XOF: 'West-Afrikaanse CFA-frank',
    XPF: 'Franse Pacific frank',
    YER: 'Jemenitische rial',
    ZAR: 'Zuid-Afrikaanse rand',
    ZMW: 'Zambiaanse kwacha',
    ZWL: 'Zimbabwaanse dollar'
  },
  countries: {
    AF: 'Afghanistan',
    AX: 'Åland-eilanden',
    AL: 'Albanië',
    DZ: 'Algerije',
    AS: 'Amerikaans-Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua en Barbuda',
    AR: 'Argentinië',
    AM: 'Armenië',
    AW: 'Aruba',
    AU: 'Australië',
    AT: 'Oostenrijk',
    AZ: 'Azerbeidzjan',
    BS: 'Bahama’s',
    BH: 'Bahrein',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Wit-Rusland',
    BE: 'België',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia, Plurinationale Staat',
    BQ: 'Bonaire, Sint Eustatius en Saba',
    BA: 'Bosnië en Herzegovina',
    BW: 'Botswana',
    BV: 'Bouveteiland',
    BR: 'Brazilië',
    IO: 'Brits Indische Oceaanterritorium',
    BN: 'Brunei Darussalam',
    BG: 'Bulgarije',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodja',
    CM: 'Kameroen',
    CA: 'Canada',
    CV: 'Kaapverdië',
    KY: 'Kaaimaneilanden',
    CF: 'Centraal-Afrikaanse Republiek',
    TD: 'Tsjaad',
    CL: 'Chili',
    CN: 'China',
    CX: 'Christmaseiland',
    CC: 'Cocoseilanden (Keelingeilanden)',
    CO: 'Colombia',
    KM: 'Comoren',
    CG: 'Congo',
    CD: 'Congo, Democratische Republiek',
    CK: 'Cookeilanden',
    CR: 'Costa Rica',
    CI: 'Ivoorkust',
    HR: 'Kroatië',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Tsjechië',
    DK: 'Denemarken',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominicaanse Republiek',
    EC: 'Ecuador',
    EG: 'Egypte',
    SV: 'El Salvador',
    GQ: 'Equatoriaal-Guinea',
    ER: 'Eritrea',
    EE: 'Estland',
    ET: 'Ethiopië',
    FK: 'Falklandeilanden (Malvinas)',
    FO: 'Faeröer',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'Frankrijk',
    GF: 'Frans-Guyana',
    PF: 'Frans-Polynesië',
    TF: 'Franse Zuidelijke Gebieden',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgië',
    DE: 'Duitsland',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Griekenland',
    GL: 'Groenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinee',
    GW: 'Guinee-Bissau',
    GY: 'Guyana',
    HT: 'Haïti',
    HM: 'Heard en McDonaldeilanden',
    VA: 'Heilige Stoel (Vaticaanstad)',
    HN: 'Honduras',
    HK: 'Hongkong',
    HU: 'Hongarije',
    IS: 'IJsland',
    IN: 'India',
    ID: 'Indonesië',
    IR: 'Iran, Islamitische Republiek',
    IQ: 'Irak',
    IE: 'Ierland',
    IM: 'Isle of Man',
    IL: 'Israël',
    IT: 'Italië',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordanië',
    KZ: 'Kazachstan',
    KE: 'Kenia',
    KI: 'Kiribati',
    KP: 'Korea, Democratische Volksrepubliek',
    KR: 'Korea, Republiek',
    KW: 'Koeweit',
    KG: 'Kirgizië',
    LA: 'Lao Volksdemocratische Republiek',
    LV: 'Letland',
    LB: 'Libanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libië',
    LI: 'Liechtenstein',
    LT: 'Litouwen',
    LU: 'Luxemburg',
    MO: 'Macau',
    MK: 'Macedonië, Voormalige Joegoslavische Republiek',
    MG: 'Madagaskar',
    MW: 'Malawi',
    MY: 'Maleisië',
    MV: 'Maldiven',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshalleilanden',
    MQ: 'Martinique',
    MR: 'Mauritanië',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesië, Federale Staten',
    MD: 'Moldavië, Republiek',
    MC: 'Monaco',
    MN: 'Mongolië',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Marokko',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibië',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Nederland',
    NC: 'Nieuw-Caledonië',
    NZ: 'Nieuw-Zeeland',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk',
    MP: 'Noordelijke Marianen',
    NO: 'Noorwegen',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestina, Staat',
    PA: 'Panama',
    PG: 'Papoea-Nieuw-Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Filipijnen',
    PN: 'Pitcairn',
    PL: 'Polen',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Roemenië',
    RU: 'Rusland',
    RW: 'Rwanda',
    BL: 'Saint Barthélemy',
    SH: 'Sint-Helena, Ascension en Tristan Da Cunha',
    KN: 'Saint Kitts en Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (Franse Deel)',
    PM: 'Saint Pierre en Miquelon',
    VC: 'Saint Vincent en de Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tomé en Principe',
    SA: 'Saoedi-Arabië',
    SN: 'Senegal',
    RS: 'Servië',
    SC: 'Seychellen',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Nederlandse Deel)',
    SK: 'Slovakije',
    SI: 'Slovenië',
    SB: 'Salomonseilanden',
    SO: 'Somalië',
    ZA: 'Zuid-Afrika',
    GS: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
    SS: 'Zuid-Soedan',
    ES: 'Spanje',
    LK: 'Sri Lanka',
    SD: 'Soedan',
    SR: 'Suriname',
    SJ: 'Spitsbergen en Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Zweden',
    CH: 'Zwitserland',
    SY: 'Syrië',
    TW: 'Taiwan',
    TJ: 'Tadzjikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad en Tobago',
    TN: 'Tunesië',
    TR: 'Turkije',
    TM: 'Turkmenistan',
    TC: 'Turks- en Caicoseilanden',
    TV: 'Tuvalu',
    UG: 'Oeganda',
    UA: 'Oekraïne',
    AE: 'Verenigde Arabische Emiraten',
    GB: 'Verenigd Koninkrijk',
    US: 'Verenigde Staten',
    UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
    UY: 'Uruguay',
    UZ: 'Oezbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Britse Maagdeneilanden',
    VI: 'Amerikaanse Maagdeneilanden',
    WF: 'Wallis en Futuna',
    EH: 'Westelijke Sahara',
    YE: 'Jemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  states: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  },
  inlineEdit: {
    save: 'Opslaan',
    cancel: 'Annuleren'
  },
  formPageLayout: {
    discard: 'Verwijderen en teruggaan'
  },
  multiSelect: {
    clearAll: 'Alles wissen'
  },
  filterMultiSelect: {
    andMore: 'en {{count}} meer'
  },
  inlineEditTrigger: {
    edit: 'Bewerken'
  },
  searchSelect: {
    noOptions: 'Geen opties'
  },
  cardDetails: {
    title: 'Kaartgegevens: x{{lastDigits}}',
    detailsHeader: 'Kaartgegevens',
    data: {
      number: 'Kaartnummer',
      holder: 'Kaarthouder',
      expiryDate: 'Vervaldatum'
    },
    billingInformation: 'Factuurinformatie',
    billingAddress: 'Factuuradres',
    vatNumber: 'BTW-nummer',
    closeCardDetails: 'Kaartgegevens sluiten',
    copyNumber: 'Nummer kopiëren',
    copied: 'Gekopieerd'
  },
  addressPicker: {
    enterAddressManually: 'Zie je je adres niet? Voer handmatig in'
  },
  panelDocumentInfo: {
    download: 'Downloaden',
    noDocument: 'Document niet geüpload'
  },
  accountBalances: {
    availableBalance: 'Beschikbaar saldo'
  },
  payAccountlayout: {
    loading: 'Laden...',
    select: 'Selecteer'
  }
};
exports.default = _default;